import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxChange, MatCheckbox } from '@angular/material/checkbox';
import { MatLabel } from '@angular/material/input';
import { NgClass } from '@angular/common';
import { E2eIdDirective } from '@lc/ui/lib/core';
import { InputField } from '../input-field';

@Component({
  selector: 'lc-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    },
  ],
  imports: [
    MatCheckbox,
    FormsModule,
    ReactiveFormsModule,
    MatLabel,
    NgClass,
    E2eIdDirective,
  ],
})
export class CheckboxComponent extends InputField {
  @Input()
    checked: boolean;

  @Input()
    label: string;

  @Input()
    hint: string;

  @Input()
    readonly: boolean;

  @Input()
    disabled: boolean;

  @Input() showErrors: boolean;

  @Output()
  readonly blur = new EventEmitter<void>();

  @Output() readonly toggled = new EventEmitter<boolean>();

  public onBlur() {
    this.blur.emit();
    this.executeOnTouched();
  }

  public onChanged(event: MatCheckboxChange) {
    this.toggled.emit(event?.checked);
  }
}
